// Tooth glyph — lucide has no tooth icon, so this is a hand-rolled one drawn on
// the same 24×24 grid / stroke conventions as lucide-react (path from Tabler
// Icons, MIT). `filled` paints it solid, used to separate two states of the same
// dental flag without changing the shape.
export default function ToothIcon({ size = 16, filled = false, strokeWidth = 2, className = '', ...rest }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size} height={size} viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor" strokeWidth={strokeWidth}
      strokeLinecap="round" strokeLinejoin="round"
      className={className} aria-hidden="true" {...rest}
    >
      <path d="M12 5.5c-1.074-.7-2.5-1.5-4.5-1.5-2.5 0-4.5 1.5-4.5 4.5 0 2.5 1.5 4.5 2 6.5.5 2 .5 4 1.5 4.5 1 .5 2-1 2.5-3 .5-2 .5-3.5 3-3.5s2.5 1.5 3 3.5c.5 2 1.5 3.5 2.5 3 1-.5 1-2.5 1.5-4.5.5-2 2-4 2-6.5 0-3-2-4.5-4.5-4.5-2 0-3.426.8-4.5 1.5z" />
    </svg>
  )
}
